import React from "react";
import {Card} from "antd";

export function TermsCard() {
    return <Card>
        Products sold at Whole Foods Market must comply with our standards for acceptable and unacceptable ingredients for the applicable category. <br/>
        Products are only eligible for sale if they contain ingredients we have specifically deemed “acceptable” or "restricted use" for the product category, with the specific use restrictions being met.
        For more information visit <a href="https://innerview.wholefoods.com/pages/quality-standards-sustainability/ingredient/">Ingredient Standards and Policies</a> on Innerview or contact the Quality Standards team.
    </Card>
}